import { Trans } from 'react-i18next';
import StyledReduceFooterCard from '/business/shared/components/pages/reduce/v3/nav/__styled__/StyledReduceFooterCard';
import LinkButton from '/shared/components/widgets/button/LinkButton';
import StyledHeading from '/shared/styled/components/StyledHeading';
import StyledParagraph from '/shared/styled/components/StyledParagraph';
import useUrlBuilder from '/business/shared/hooks/useUrlBuilder';
import type { ReduceNavItem } from './nav';
type ReduceFooterCardProps = {
  $isInvertedFooter?: boolean;
  applicationId: number | null;
  navItem: ReduceNavItem;
};
function ReduceFooterCard({ navItem, applicationId, $isInvertedFooter = false }: ReduceFooterCardProps) {
  const { getApplicationUrl } = useUrlBuilder();

  return (
    <StyledReduceFooterCard $isInvertedFooter={$isInvertedFooter}>
      <div>
        <img src={navItem.icon} alt="" />
        <StyledHeading $bold $type="h6" as="h6">
          <Trans i18nKey={`business:ReducePageV3.${navItem.key}.footer.title`} />
        </StyledHeading>
        <StyledParagraph $smallText $bold>
          <Trans i18nKey={`business:ReducePageV3.${navItem.key}.footer.desc`} />
        </StyledParagraph>
      </div>
      <LinkButton key={navItem.key} $primary to={getApplicationUrl(`/reduce/${navItem.url}`, applicationId)}>
        <Trans i18nKey={`business:ReducePageV3.${navItem.key}.footer.linkText`} />
      </LinkButton>
    </StyledReduceFooterCard>
  );
}
export default ReduceFooterCard;
